// Wizard step indicator — RON-5466 Phase 2. Prototype component: `StepBar`.
//
// The shared `Common/StepProgress.jsx` is NOT reused: it hardcodes step counts per booking tab
// (parking/desking/meeting), renders numbers only, and has no notion of labels or a completed
// state. Widening it would have meant changing a component three other screens depend on.

import { useTranslation } from "react-i18next";

const VisitorStepBar = ({ steps, current }) => {
  const { t } = useTranslation("common");

  return (
    <ol className="visitor-steps" aria-label={t("react_visitors_progress")}>
      {steps.map((labelKey, index) => {
        const isDone = index < current;
        const isCurrent = index === current;

        return (
          <li
            key={labelKey}
            className={`visitor-steps__item${
              isDone ? " visitor-steps__item--done" : ""
            }${isCurrent ? " visitor-steps__item--current" : ""}`}
            aria-current={isCurrent ? "step" : undefined}
          >
            <span className="visitor-steps__marker">
              {isDone ? "✓" : index + 1}
            </span>
            <span className="visitor-steps__label">{t(labelKey)}</span>
          </li>
        );
      })}
    </ol>
  );
};

export default VisitorStepBar;
